import {useCallback} from 'react';
import {useSelector} from 'react-redux';


import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {searchNotification} from 'src/openapi/admin/apis/InternalNotificationSearchApi';
import {useAppDispatch} from 'src/store/hooks';

import {notificationsListStateSelector} from '../slices/notification-search-criteria.slice';

import type {NotificationSearchCriteria} from 'src/openapi/admin/models/NotificationSearchCriteria';

export const useSearchNotification = () => {
    const apiDispatch = useAppDispatch();

    const state = useSelector(notificationsListStateSelector);

    const getDispatchAction = useCallback(() => apiDispatch(searchNotification({
        searchCriteria: {
            sorting: {
                sortField: state.sortCriteria.field,
                sortDirection: state.sortCriteria.direction,
            },
            pagination: state.pagination,
            criteria: (state.filters || {}) as NotificationSearchCriteria,
        },
    })), [state, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: {
            notifications: [],
            total: 0,
        },
        getDispatchAction,
        shouldLoadData: false,
    });
};
